module.exports = __webpack_public_path__ + "static/icons/icons-logos-bancos.a7537f5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-tarjeta-credito/icons-logos-bancos.svg
// module id = To1i
// module chunks = 1